import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import DeviceTable from "../components/DeviceTable/DeviceTable";
import { useTitle } from "../hooks/useTitle";
import { useTranslation } from "react-i18next";

const DevicePage = () => {
  const { t } = useTranslation();

  useTitle(t("page-title.devices"));
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 1000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-end",
        marginTop: "2.5rem",
      }}
    >
      <Button
        onClick={() => navigate("/portal/add-device")}
        style={{ paddingInline: "1.2rem", marginBottom: "0.5rem" }}
      >
        {t("pages.devices.add-device")}
      </Button>
      <DeviceTable />
    </div>
  );
};

export default DevicePage;
